module.exports = __webpack_public_path__ + "static/media/usbkey.780cec33.png";